import { FeatureCollection, Feature } from "geojson";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Attribute } from "../../../types";
import { formatProperty } from "../../../utils/PropertyUtils";
import { LayerProperty } from "./LayerProperty";
import { useProperties } from "../../../hooks/propertyHooks";

interface Props {
  attributes: Attribute[];
  groupingKey: string | undefined;
  feature: Feature | FeatureCollection | undefined;
}

export function LayerProperties(props: Props) {
  const { feature, groupingKey, attributes } = props;
  const { t } = useTranslation();
  const properties = useProperties(feature, groupingKey);
  const sortedAttributes = attributes.sort(
    (a, b) => (a.order || -1) - (b.order || -1)
  );

  return render();

  function render() {
    if (!properties) return null;

    return (
      <>
        {sortedAttributes.map((attribute) =>
          properties.map((property, i) => (
            <LayerProperty
              key={`${attribute.key}-${i}`}
              className="layer-property"
              label={
                !groupingKey
                  ? attribute.label
                  : `${property[attribute.label] || ""}`
              }
              value={formatProperty(property[attribute.key], attribute)}
            />
          ))
        )}
        {!properties && attributes.length > 0 && (
          <Typography component="label" className="attribute-label">
            {t("label.noPropertiesForThisPoint")}
          </Typography>
        )}
      </>
    );
  }
}
